import type { BuilderDaSimulacao } from '../../types';
import { mesclarEventos, maiorSeq } from '../../utils/eventosDaSimulacao';
import { progressoDaExportacaoRecebido } from '../eventosDoStore';
import { buscarEventosDaSimulacao, exportarEventosDaSimulacao } from './actions';

export function registrarEventosDaSimulacao(builder: BuilderDaSimulacao): void {
  builder
    .addCase(buscarEventosDaSimulacao.pending, (state, action) => {
      if (state.simulacao?.id === action.meta.arg.simulacaoId) state.carregandoEventos = true;
    })
    .addCase(buscarEventosDaSimulacao.fulfilled, (state, action) => {
      if (state.simulacao?.id !== action.payload.simulacaoId) return;
      state.falhaDaSincronizacao.eventos = false;
      state.carregandoEventos = false;
      state.erroDosEventos = null;
      state.eventos = mesclarEventos(state.eventos, action.payload.eventos);
      state.ultimoSeq = maiorSeq(state.eventos, state.ultimoSeq);
      state.seqConhecido = Math.max(state.seqConhecido, action.payload.ultimoSeq);
      state.temMaisEventos = state.ultimoSeq < state.seqConhecido;
      state.leituraFinalConcluida =
        state.simulacao.status === 'ENCERRADA' &&
        !state.temMaisEventos &&
        state.ultimoSeq >= state.simulacao.ultimoSeq;
    })
    .addCase(buscarEventosDaSimulacao.rejected, (state, action) => {
      if (state.simulacao?.id !== action.meta.arg.simulacaoId) return;
      state.falhaDaSincronizacao.eventos = true;
      state.carregandoEventos = false;
      state.erroDosEventos = action.payload ?? null;
    })
    .addCase(exportarEventosDaSimulacao.pending, (state) => {
      state.exportacao = {
        carregando: true,
        carregados: state.eventos.length,
        total: state.seqConhecido,
      };
    })
    .addCase(progressoDaExportacaoRecebido, (state, action) => {
      if (state.simulacao?.id !== action.payload.simulacaoId) return;
      state.exportacao.carregados = action.payload.carregados;
      state.exportacao.total = action.payload.total;
    })
    .addCase(exportarEventosDaSimulacao.fulfilled, (state) => {
      state.exportacao.carregando = false;
    })
    .addCase(exportarEventosDaSimulacao.rejected, (state) => {
      state.exportacao.carregando = false;
    });
}
